import { closePopups, openPopup } from '../../init';

const iframe = <HTMLIFrameElement>document.getElementById('iframe-document-preview');
const btnClose = <HTMLButtonElement>document.getElementById('closePopup');

class DocumentViewer {
    static openIFrame = async (url: string) => {
        iframe.src = url;

        const target = document.getElementById('document-preview');
        if (target) {
            document.documentElement.classList.add('popup_open');
            target.classList.add('open');
            document.documentElement.querySelector('.backface')!.classList.add('open');
        }
    };
}

if (btnClose) {
    btnClose.addEventListener('click', () => closePopups());
}

if (iframe) {
    iframe.addEventListener('load', () => {
        const ele = iframe.contentWindow!.document.getElementsByTagName('img')[0];
        if (ele && ele.width && ele.width > 600) {
            ele.style.width = '100%';
            ele.style.height = 'auto';
        }
    });
}


export default DocumentViewer;
